
import { required } from '~/services/validators';
import formMixin from '~/services/form';

export default {
    name: 'BusinessBan',
    mixins: [formMixin],
    props: {
        business: {
            type: Object,
            required: true,
        },
    },
    methods: {
        async ban() {
            if (this.reason) {
                const endpoint = this.$config.endpoints.organisationBan.replace('{slug}', this.business.slug);
                const { message } = await this.$form.submit(endpoint, '$put', { reason: this.reason });
                this.$store.dispatch('setFlashMessage', { message });
                this.$emit('banned');
            }
        },
    },
    validations: {
        reason: [required],
    },
};
